export default "__VITE_ASSET__ykmSZNBk__"